package com.trevorwiebe.timesheet.core.domain

// The browser exposes no runtime app-version API (unlike Android's PackageManager
// or iOS's NSBundle), so there is nothing to report on web.
actual fun appVersion(): String = ""
